module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.preventClose
    }
  }, [_c('modal-non-clickable', {
    class: _vm.getClassMobile(),
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close,
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.preventClose.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "training-editor-modal-panel",
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.title) + "\n          "), _vm._l((_vm.languages), function(item, index) {
    return _c('span', {
      class: _vm.getChipClassLanguage(item, index),
      on: {
        "click": function($event) {
          return _vm.onSelectedLanguage(item, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.isSelectedLanguage(item, index) ? '✔ ' : '') + " " + _vm._s(item.name) + " ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('H1', [_vm._v(_vm._s(_vm.date))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedLanguageIndex === 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_name')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_td_name'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20px"
    }
  }), _vm._v(" "), (_vm.selectedLanguageIndex === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_name_en')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enName),
      expression: "model.enName"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_td_name_en'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.enName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enName", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedLanguageIndex === 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_short_desc')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.shortDescription),
      expression: "model.shortDescription"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_td_short_desc'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.shortDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "shortDescription", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedLanguageIndex === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_short_desc_en')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enShortDescription),
      expression: "model.enShortDescription"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_td_short_desc_en'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.enShortDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enShortDescription", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedLanguageIndex === 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_long_desc')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.longDescription),
      expression: "model.longDescription"
    }],
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "color": "black"
    },
    attrs: {
      "rows": "20"
    },
    domProps: {
      "value": (_vm.model.longDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "longDescription", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.selectedLanguageIndex === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_long_desc_en')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enLongDescription),
      expression: "model.enLongDescription"
    }],
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "color": "black"
    },
    attrs: {
      "rows": "20"
    },
    domProps: {
      "value": (_vm.model.enLongDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enLongDescription", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_type_training')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingType),
      expression: "model.trainingType"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_wod_type_training'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.trainingType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "trainingType", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_category')) + " "), _c('p', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        _vm.showAddCategory = !_vm.showAddCategory
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  })])]), _vm._v(" "), (_vm.showAddCategory) ? _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory),
      expression: "newCategory"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_td_add_category_insert_name'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.newCategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCategory = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLoadingCategory) ? _c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddCategory && !_vm.isLoadingCategory) ? _c('div', {
    staticClass: "new-button",
    staticStyle: {
      "margin-top": "16px"
    },
    on: {
      "click": function($event) {
        return _vm.addTypeCategory()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_td_add_category_save_name')))]) : _vm._e(), _vm._v(" "), (!_vm.showAddCategory) ? _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategory),
      expression: "selectedCategory"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_category_choose')))]), _vm._v(" "), _vm._l((_vm.categories), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                      " + _vm._s(item.name) + "\n                    ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.showAddCategory && _vm.selectedCategory !== 'null') ? _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "16px"
    },
    on: {
      "click": function($event) {
        return _vm.deleteCategory()
      }
    }
  }, [_c('i', {
    staticClass: "ti-trash",
    staticStyle: {
      "color": "#FF0000"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_category_choosed_delete')) + ": " + _vm._s(_vm.selectedCategory != null ? _vm.selectedCategory.name : ''))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_coach_notes')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.coachNotes),
      expression: "model.coachNotes"
    }],
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "color": "black"
    },
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.model.coachNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "coachNotes", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "cover-result"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_results_config')) + " "), _c('p', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        _vm.showAddMeasures = !_vm.showAddMeasures
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  })])]), _vm._v(" "), (_vm.showAddMeasures) ? _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMeasure),
      expression: "newMeasure"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_td_add_measure_insert_name'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.newMeasure)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMeasure = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLoadingMeasure) ? _c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddMeasures && !_vm.isLoadingMeasure) ? _c('div', {
    staticClass: "new-button",
    staticStyle: {
      "margin-top": "16px"
    },
    on: {
      "click": function($event) {
        return _vm.addMeasure()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_td_add_result_measure')))]) : _vm._e(), _vm._v(" "), (!_vm.showAddMeasures) ? _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMeasure),
      expression: "selectedMeasure"
    }],
    staticClass: "form-control input",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMeasure = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_measure_choose')))]), _vm._v(" "), _vm._l((_vm.trainingMeasures), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                      " + _vm._s(item.name) + "\n                    ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.resultRounds),
      expression: "model.resultRounds"
    }],
    staticClass: "form-control input",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_td_result_rounds'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.resultRounds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "resultRounds", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.showAddMeasures && _vm.selectedMeasure !== 'null') ? _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "16px"
    },
    on: {
      "click": function($event) {
        return _vm.deleteMeasure()
      }
    }
  }, [_c('i', {
    staticClass: "ti-trash",
    staticStyle: {
      "color": "#FF0000"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_measure_choosed_delete')) + ": " + _vm._s(_vm.selectedMeasure != null ? _vm.selectedMeasure.name : ''))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_total_result')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.advanceOptions),
      expression: "model.advanceOptions"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "advanceOptions", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_td_total_result_choose')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MIN"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_total_result_min')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MAX"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_total_result_max')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AVERAGE"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_total_result_average')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SUM"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_total_result_sum')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_result_sort')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sortType),
      expression: "model.sortType"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "sortType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_result_sort_asc')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_wod_result_sort_desc')))])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addTraining
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n                ")])])])])], 1)])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-688dcaa9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddTrainingDefinitionWod.vue
// module id = 778
// module chunks = 0